"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiHeader = void 0;
const react_1 = require("react");
const React = require("react");
require("./kpi-header.less");
class KpiHeader extends react_1.Component {
    render() {
        const { children = [], center = true, decoration // B-104
         } = this.props;
        // B-104
        const type = (decoration === null || decoration === void 0 ? void 0 : decoration.type) === undefined ? 'initial' : decoration === null || decoration === void 0 ? void 0 : decoration.type;
        const zIndex = (decoration === null || decoration === void 0 ? void 0 : decoration.zIndex) === undefined ? '0' : decoration === null || decoration === void 0 ? void 0 : decoration.zIndex;
        const isTop = (decoration === null || decoration === void 0 ? void 0 : decoration.top) === undefined ? '0' : decoration === null || decoration === void 0 ? void 0 : decoration.top;
        const width = (decoration === null || decoration === void 0 ? void 0 : decoration.width) === undefined ? '100%' : decoration === null || decoration === void 0 ? void 0 : decoration.width;
        const childrenArray = Array.isArray(children) ? children : [children];
        const centerChildren = center
            ? " kpi-header__center-children"
            : " kpi-header__flex-children";
        return (
        // B-104
        React.createElement("div", { className: `kpi-header${centerChildren}`, style: { position: type, top: isTop, zIndex: zIndex, width: width } }, this.renderChildren(childrenArray, center)));
    }
    renderChildren(children, center) {
        const className = center ? "" : " kpi-header__child-container--flex";
        const dividerClassName = center
            ? " kpi-header__long-divider"
            : " kpi-header__short-divider";
        return children.map((child, index) => (React.createElement("div", { className: `kpi-header__child-container${className}`, key: index },
            child,
            this.props.noDivider || index === children.length - 1 ? null : (React.createElement("div", { className: `kpi-header__divider${dividerClassName}` })))));
    }
}
exports.KpiHeader = KpiHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-header.tsx
// module id = 2783
// module chunks = 0 1